module.exports = __webpack_public_path__ + "gb.svg?fe60f8318501f211b9583bc6d666c874";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/gb.svg
// module id = 1108
// module chunks = 0